import React, { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory, useLocation } from 'react-router';
import * as R from 'ramda';
import { Paiement } from './main';
import { GetEtablissementInvoicesToBill, GetEtablissementInvoicesToPay, GetPartnerInvoicesToBill, GetPartnerInvoicesToPay } from '../../actions/partner/partner';

export const Payment = ({ partner, etablissement }) => {
    const dispatch = useDispatch();
    const searchQuery = useLocation();
    const history = useHistory();
    const pageQuery = new URLSearchParams(searchQuery.search);

    let page = pageQuery.get('page');
    let search = pageQuery.get('search');
    let status = pageQuery.get('status');
    let startDate = pageQuery.get('startDate');
    let endDate = pageQuery.get('endDate');
    let sortBy = pageQuery.get('sortBy');
    let sortDesc = pageQuery.get('sortDesc');

    page = R.isNil(page) ? 1 : parseInt(page);
    search = R.isNil(search) ? "" : search;
    status = R.isNil(status) ? "" : status;
    startDate = R.isNil(startDate) ? "" : startDate;
    endDate = R.isNil(endDate) ? "" : endDate;
    sortBy = R.isNil(sortBy) ? "creationdate" : sortBy;
    sortDesc = R.isNil(sortDesc) ? "true" : sortDesc;

    const [pageSearch, setPageSearch] = useState(search);
    const [invoices, setInvoices] = useState({
        isLoading: undefined,
        items: [],
        totalPages: 0,
        totalRecords: 0,
        currentPage: 0

    });
    const [date, setDate] = useState({
        startDate: !R.isEmpty(startDate) ? new Date(startDate) : undefined,
        endDate: !R.isEmpty(endDate) ? new Date(endDate) : undefined
    });

    const renderRef = useRef(false);
    const renderDateRef = useRef(false);


    useEffect(() => {

        if (isNaN(page) || page === 0) {
            history.push("/partner/paiement");
            return;
        }

        //pageNumber, searchTerm, sortByTerm, sortDesc
        //dispatch(fetchClientsInvoices(page, search, status, startDate, endDate, sortBy, sortDesc));

        setInvoices({ ...invoices, isLoading: true });
        if (R.isNil(etablissement)) {
            Promise.all([GetPartnerInvoicesToPay(partner.id), GetPartnerInvoicesToBill(partner.id)])
                .then((data) => {
                    const invoices = data[0].items.concat(data[1].items).filter(i => i.recipientType !== "USER").filter(i => i.totalToBill !== 0 || i.totalToPay !== 0);
                    // setInvoices(
                    //     { ...invoices, 
                    //     isLoading: false ,
                    //     totalPages: 0,
                    //     totalRecords: 0,
                    //     currentPage: 0
                    // });
                });
        } else {
            Promise.all([GetEtablissementInvoicesToPay(etablissement.id), GetEtablissementInvoicesToBill(etablissement.id)])
                .then((data) => {

                    let items = data[0].items.map(i => { return { ...i, number: R.isNil(i.number) ? '' : i.number, date: new Date(i.created), etablissement: etablissement.name, totalToPay: i.issuerId !== etablissement.id ? i.amount : 0, totalToBill: i.issuerId === etablissement.id ? i.amount : 0 }; });
                    let items2 = data[1].items.map(i => { return { ...i, number: R.isNil(i.number) ? '' : i.number, date: new Date(i.created), etablissement: etablissement.name, totalToPay: i.issuerId !== etablissement.id ? i.amount : 0, totalToBill: i.issuerId === etablissement.id ? i.amount : 0 }; });
                    const allInvoices = items.concat(items2).filter(i => i.recipientType !== "USER").filter(i => i.totalToBill !== 0 || i.totalToPay !== 0);
                    setInvoices(
                        {
                            ...invoices,
                            items: allInvoices,
                            isLoading: false,
                            totalPages: data[0].totalPages > data[1].totalPages ? data[0].totalPages : data[1].totalPages,
                            totalRecords: data[0].totalRecords > data[1].totalRecords ? data[0].totalRecords : data[1].totalRecords,
                            currentPage: data[0].pageNumber > data[1].pageNumber ? data[0].pageNumber + 1 : data[1].pageNumber + 1
                        });

                });
        }


        // eslint-disable-next-line 
    }, [searchQuery.search, history.location]);


    let timer = null;
    useEffect(() => {

        if (!renderRef.current) {
            renderRef.current = true;
            return;
        };

        if (R.isEmpty(pageSearch)) {
            history.push(`/partner/paiement?page=${1}${status !== "" ? "&status=" + status : ""}${startDate !== "" ? "&startDate=" + startDate : ""}${endDate !== "" ? "&endDate=" + endDate : ""}${sortBy !== "" ? "&sortBy=" + sortBy : ""}${sortDesc === "false" ? "&sortDesc=false" : "&sortDesc=true"}`);
            return;
        }

        clearTimeout(timer);
        timer = setTimeout(() => {
            //dispatch(fetchClientsInvoices(page, pageSearch, status, startDate, endDate, sortBy, sortDesc));
        }, 1000);


        return () => clearTimeout(timer);

        // eslint-disable-next-line 
    }, [pageSearch]);


    useEffect(() => {

        if (!renderDateRef.current) {
            renderDateRef.current = true;
            return;
        };

        if (!R.isEmpty(date.startDate) && !R.isNil(date.startDate) && !R.isNil(date.endDate) && !R.isEmpty(date.endDate)) {
            history.push(`/partner/paiement?page=${1}${pageSearch !== "" ? "&search=" + pageSearch : ""}${status !== "" ? "&status=" + status : ""}${"&startDate=" + (date.startDate.toISOString().slice(0, 10))}${"&endDate=" + (date.endDate.toISOString().slice(0, 10))}${sortBy !== "" ? "&sortBy=" + sortBy : ""}${sortDesc === "false" ? "&sortDesc=false" : "&sortDesc=true"}`);
            return;

        } else if (!R.isEmpty(date.startDate) && !R.isNil(date.startDate)) {
            history.push(`/partner/paiement?page=${1}${pageSearch !== "" ? "&search=" + pageSearch : ""}${status !== "" ? "&status=" + status : ""}${"&startDate=" + (date.startDate.toISOString().slice(0, 10))}${sortBy !== "" ? "&sortBy=" + sortBy : ""}${sortDesc === "false" ? "&sortDesc=false" : "&sortDesc=true"}`);
            return;

        } else if (!R.isNil(date.endDate) && !R.isEmpty(date.endDate)) {
            history.push(`/partner/paiement?page=${1}${pageSearch !== "" ? "&search=" + pageSearch : ""}${status !== "" ? "&status=" + status : ""}${"&endDate=" + (date.endDate.toISOString().slice(0, 10))}${sortBy !== "" ? "&sortBy=" + sortBy : ""}${sortDesc === "false" ? "&sortDesc=false" : "&sortDesc=true"}`);
            return;

        } else {
            history.push(`/partner/paiement?page=${1}${pageSearch !== "" ? "&search=" + pageSearch : ""}${status !== "" ? "&status=" + status : ""}`);
        }

        // eslint-disable-next-line 
    }, [date]);

    const routerQuery = {
        page,
        search,
        status,
        sortBy,
        sortDesc,
        endDate,
        startDate,
        date
    };

    //if (!R.isEmpty(invoices.items)) return "";

    return (
        <Paiement partner={partner} invoices={invoices} etablissement={etablissement} routerQuery={routerQuery} pageSearch={pageSearch} setPageSearch={setPageSearch} date={date} setDate={setDate} />
    );
};

